//@flow
const ENTITY_IMPORT_TASK_TYPE_ENUM = Object.freeze({
    REGISTER_HELPERS: 'REGISTER_HELPERS',
    PARSE_CSV: 'PARSE_CSV',
    PARSE_CSV_COMPLETE: 'PARSE_CSV_COMPLETE',
    PREPARE_TABLE_DATA: 'PREPARE_TABLE_DATA',
    VALIDATE_ENTITY_IDS: 'VALIDATE_ENTITY_IDS',
    GENERATE_ID_VALIDATION_TABLE_DATA: 'GENERATE_ID_VALIDATION_TABLE_DATA',
    SET_OTHER_VALIDATION_TABLE: 'SET_OTHER_VALIDATION_TABLE',
    VALIDATE_ENTITIES: 'VALIDATE_ENTITIES',
    UPDATE_TABLE_DATA: 'UPDATE_TABLE_DATA',
    GET_ENTITIES_TO_UPLOAD: 'GET_ENTITIES_TO_UPLOAD',
    GET_ERROR_ENTITIES_DATA_FOR_DOWNLOAD:
        'GET_ERROR_ENTITIES_DATA_FOR_DOWNLOAD',
    GET_IGNORED_ENTITIES_ENTITIES_DATA_FOR_DOWNLOAD:
        'GET_IGNORED_ENTITIES_ENTITIES_DATA_FOR_DOWNLOAD',
    REORDER_TABLE_ERRORS: 'REORDER_TABLE_ERRORS',
    GET_NEXT_PAGE: 'GET_NEXT_PAGE',
    RESET_IMPORT: 'RESET_IMPORT',
    RETRY_FAILED_ACTION: 'RETRY_FAILED_ACTION',
    GET_RESERVED_ENTITIES_ENTITIES_DATA_FOR_DOWNLOAD:
        'GET_RESERVED_ENTITIES_ENTITIES_DATA_FOR_DOWNLOAD'
});

export const MSG_STATUS_ENUM = Object.freeze({
    SUCCESS: 'SUCCESS',
    ERROR: 'ERROR'
});

export type ImportTaskTypeEnumType = $Values<
    typeof ENTITY_IMPORT_TASK_TYPE_ENUM
>;
export type MsgStatusEnumType = $Values<typeof MSG_STATUS_ENUM>;

export default ENTITY_IMPORT_TASK_TYPE_ENUM;
